"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CtopageState_1 = require("./CtopageState");
var styles = require("./Ctopage.css");
var Button_1 = require("../Button/Button");
var Ctopage = /** @class */ (function (_super) {
    __extends(Ctopage, _super);
    function Ctopage(props) {
        var _this = _super.call(this, props) || this;
        _this.messageParentClass = '';
        _this.messageIconClass = '';
        _this.messageChildClass = '';
        _this.state = new CtopageState_1.default();
        _this.closeCtopage = _this.closeCtopage.bind(_this);
        return _this;
        // this.setDefaultClasses();
    }
    Ctopage.prototype.componentDidMount = function () {
        // if (this.props.data.timeToDisplay) {
        //   this.displayTimer = window.setTimeout(this.closeCtopage, this.props.data.timeToDisplay * SECOND);
        // }
    };
    Ctopage.prototype.closeCtopage = function () {
        var _this = this;
        this.setState({ show: false }, function () {
            if (_this.props.events && _this.props.events.onClose) {
                _this.props.events.onClose();
            }
            if (_this.props.events && _this.props.events.removeFromList) {
                _this.props.events.removeFromList(_this.props.data.id);
            }
        });
    };
    Ctopage.prototype.render = function () {
        return (React.createElement("div", { "data-test-id": this.props.testId, tabIndex: 0 },
            React.createElement("div", null,
                React.createElement("i", { className: [styles.messageIcon, this.messageIconClass].join(' '), role: "img", "aria-label": "icon" })),
            React.createElement("p", { className: styles.messageContent, tabIndex: 0, dangerouslySetInnerHTML: { __html: this.validContent() } }),
            React.createElement(Button_1.default, { data: { text: 'Button' }, events: { onClick: this.closeCtopage } })));
    };
    Ctopage.prototype.validContent = function () {
        var temp = document.createElement('div');
        var decodeFlag = (this.props.data.isDecodingRequired !== undefined ?
            this.props.data.isDecodingRequired :
            true);
        var content = '';
        if (decodeFlag) {
            content = decodeURIComponent(this.props.data.text);
        }
        else {
            content = this.props.data.text;
        }
        temp.innerHTML = content;
        return this.isApprovedContent(Array.prototype.slice.call(temp.querySelectorAll('*')))
            ? content : 'INVALID';
    };
    Ctopage.prototype.isApprovedContent = function (elements) {
        // search for dis-allowed tags
        return elements.find(function (element) {
            var allowed = Ctopage.allowedTags[element.tagName];
            if (allowed) {
                if (Array.prototype.slice.call(element.attributes).find(function (attribute) { return allowed.indexOf(attribute.name) < 0; })) {
                    allowed = undefined; // found dis-allowed attribute
                }
            }
            return !allowed; // return true if dis-allowed element found
        }) === undefined;
    };
    Ctopage.allowedTags = {
        A: ['href', 'id', 'class', 'target'],
        B: ['role'],
        BR: [],
        DIV: ['class', 'id'],
        H1: ['class', 'id'],
        H2: ['class', 'id'],
        H3: ['class', 'id'],
        H4: ['class', 'id'],
        H5: ['class', 'id'],
        H6: ['class', 'id'],
        I: ['role'],
        LI: [],
        P: ['class', 'id', 'role'],
        SPAN: ['class', 'id', 'role'],
        STRONG: [],
        SUB: [],
        SUP: [],
        U: [],
        UL: [],
    };
    Ctopage.defaultProps = {
        options: {
            accessibility: '',
            className: {},
            closeButton: true,
            decorated: true,
        },
    };
    return Ctopage;
}(React.Component));
exports.default = Ctopage;
//# sourceMappingURL=Ctopage.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Ctopage/Ctopage.js
// module id = 1135
// module chunks = 8